import React from 'react';
import { Link } from 'react-router-dom';
import Header from './shared/Header';
import Navigation from './shared/Navigation';
import { getRandomColor } from '../utils/colors';
import { useRandomLinkColors } from '../utils/useRandomLinkColors';
const NewsPage = () => {
  // Use our custom hook
  useRandomLinkColors();
  return <div className="min-h-screen bg-[#faf9f7] text-[#333333] font-serif" data-id="element-350">
      <Header data-id="element-351" />
      <main className="flex min-h-screen pt-24 px-6" data-id="element-352">
        <div className="flex flex-col md:flex-row w-full max-w-6xl mx-auto" data-id="element-353">
          <div className="w-full md:w-1/4 mb-8 md:mb-0" data-id="element-354">
            <Navigation data-id="element-355" />
          </div>
          <div className="w-full md:w-3/4 md:pl-8" data-id="element-356">
            <div className="max-w-2xl" data-id="element-357">
              <div className="mb-8" data-id="element-358">
                <p className="mb-4" data-id="element-359">Check back soon for news!</p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>;
};
export default NewsPage;